import * as React from 'react';

const YoutubeIcon = () => {
	return (
		<svg width='28' height='18' viewBox='0 0 28 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M4.74455 17.3333H22.3632C24.9835 17.3333 27.1079 15.2848 27.1079 12.7578V4.5755C27.1079 2.04853 24.9835 0 22.3632 0H4.74455C2.12422 0 0 2.04853 0 4.5755V12.7578C0 15.2848 2.12422 17.3333 4.74455 17.3333ZM10.7746 4.46064L18.3286 8.66655L10.7746 12.8726V4.46064Z'
				fill='#BBB5AA'
			/>
		</svg>
	);
};
export default YoutubeIcon;
